import { render, staticRenderFns } from "./DeActivateResponsibility.vue?vue&type=template&id=48799d93"
import script from "./DeActivateResponsibility.vue?vue&type=script&lang=js"
export * from "./DeActivateResponsibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports